<template>
  <div>
    <parent-list-item v-if="isFolder" class="cursor-pointer" :file="value" :open="open" can-edit :has-child-files="hasChildren" @click.native="open = !open" />
    <list-item v-else :file="value" can-edit />
    <d-expand-transition v-show="isFolder && open">
      <div class="ml-10 border-l border-primary-500">
        <draggable
          :list="value.childItems"
          :ghost-class="isFolder ? 'pb-5' : ''"
          :group="group"
          v-bind="dragOptions"
          @start="drag = true"
          @end="drag = false"
          item-key="id"
        >
          <template #item="{element}">
            <categorized-files-tree-node
              :collapse-all="collapseAll"
              :value="element"
              :group="group"
              :row-key="rowKey"
            />
          </template>
        </draggable>
      </div>
    </d-expand-transition>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable';
  import { ListingItemType } from '@resources/scripts/constants';
  import ParentListItem from '../ListItem/ParentListItem.vue';
  import ListItem from '../ListItem/ListItem.vue';

  export default {
    name: 'CategorizedFilesTreeNode',
    components: {
      Draggable,
      ParentListItem,
      ListItem,
    },

    props: {
      value: {
        type: Object,
        default: () => ({}),
      },
      root: {
        type: Boolean,
        default: () => false,
      },
      group: {
        type: String,
        default: null,
      },
      rowKey: {
        type: String,
        default: 'key',
      },
      collapseAll: Boolean,
    },

    data() {
      return {
        open: true,
        drag: false,
        localValue: { ...this.value },
      };
    },

    computed: {
      hasChildren() {
        return this.value.childItems != null && this.value.childItems.length > 0;
      },

      isFolder() {
        return this.value.type === ListingItemType.FOLDER;
      },

      dragOptions() {
        return {
          animation: 200,
          group: 'files',
          disabled: false,
        };
      },
    },

    watch: {
      collapseAll(val) {
        if (val) this.open = false;
      },

      value(value) {
        this.localValue = { ...value };
      },
    },
  };
</script>